import { Toast as AntdToast } from 'antd-mobile';

export default class Toast {
  static info(content, duration) {
    AntdToast.info(content, duration, null, false);
  }

  static offline(content, duration, onClose = null, mask = true) {
    AntdToast.offline(content, duration, onClose, mask);
  }

  static success(content, duration) {
    AntdToast.success(content, duration, null, false);
  }

  static fail(content, duration, onClose = null, mask = false) {
    AntdToast.fail(content, duration, onClose, mask);
  }

  static loading(content = '加载中', duration = 999999) {
    AntdToast.loading(content, duration, null, false);
  }

  static hide() {
    AntdToast.hide();
  }
}



// WEBPACK FOOTER //
// ./src/components/toast/index.js